<dashlet-table
    [dataSource]="genesysTrunkGroups$ | async"
    [columns]="columns"
    [sortField]="'severity'"
    sortDirection="desc"
    rowExpansionField="edges"
    [rowExpansionSortField]="'severity'"
    rowExpansionSortDirection="desc"
    [rowExpansionColumns]="expansionColumns"
    [menuItems]="menuItems"
    [tableHeightRows]="16"
    [loading]="loading"
></dashlet-table>
